import Image from 'next/image'
import { ChevronLeftIcon } from 'components/design-system/kickoff-icons'
import kickoffLogoDark from 'images/kickoff-logo-standard.svg'
import s from './styles.module.css'
export default function SimpleKickoffHeader({
  onBackClick,
  backgroundColor,
  style,
}: {
  onBackClick?: () => void
  backgroundColor?: string
  style?: React.CSSProperties
}) {
  return (
    <div className={s.header} style={{ backgroundColor, ...style }}>
      {onBackClick && (
        <button className={s.backWrapper} onClick={onBackClick}>
          <ChevronLeftIcon size="small" strokeWidth={2} />
        </button>
      )}
      <Image
        src={kickoffLogoDark}
        alt="Kickoff Logo"
        className={s.logo}
        width={120}
        height={40}
        priority
      />
    </div>
  )
}
